var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-350e3fcf-ca90-464d-b089-d00eee69f501",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-1ceb0fa6-bcbe-4d61-a3b6-e34805d22dfb {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-1ceb0fa6-bcbe-4d61-a3b6-e34805d22dfb",
    d: "M14.82,18.05v-.27c0-1.29.6-2.14,1.91-2.93,1.11-.68,1.54-1.3,1.54-2.28,0-1.24-.94-2.09-2.34-2.09-1.27,0-2.11.64-2.43,1.79-.16.58-.37.77-.8.77-.49,0-.76-.29-.76-.78,0-.41.08-.74.25-1.11.56-1.36,1.97-2.15,3.81-2.15,2.37,0,4.06,1.44,4.06,3.49,0,1.5-.78,2.54-2,3.27-1.21.72-1.56,1.25-1.56,2.26,0,.6-.23,1.01-.82,1.01s-.85-.44-.85-.99ZM14.57,21.91c0-.62.48-1.09,1.09-1.09s1.09.47,1.09,1.09-.47,1.09-1.09,1.09-1.09-.48-1.09-1.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.d63d811d558aec2e58b62cb4d1c43613.svg";
export { ForwardRef as ReactComponent };